export class Clients {
  static PACIFIC_REGIONAL = 'Pacific Regional';

}
